<script>
  import { parseResourceDetailData } from "./utils.js";
  import { applyTransactionsToOperations } from "../../../utils/mergeData.js";
  import { getOperationStartDateFromFixedProperty } from "../../../utils/getData.js";

  export let globalProjectData
  export let transactions
  export let resourceDetail

  let selectedStyleIndex = 0
  export const setSelectedStyleIndex = (index) => {selectedStyleIndex = index}

  $: parsedData = parseResourceDetailData(resourceDetail.Data[selectedStyleIndex])
  $: operations = applyTransactionsToOperations(parsedData.rows, transactions)
  $: dateList = Array.from(new Set(operations.map(operation => getOperationStartDateFromFixedProperty(operation, globalProjectData?.dayStartTime))))
</script>

<slot
  uploadTimestamp={resourceDetail.UploadTimeStamp}
  dateList={dateList}
  columns={parsedData.columns}
  operations={operations}
  setSelectedStyleIndex={setSelectedStyleIndex}
/>
